@if (isAuthenticated && !disabled) {
  <button
    (click)="toggleFavorite($event)"
    class="absolute  right-1 z-10 p-1 rounded-full bg-white/80 backdrop-blur-sm shadow-md hover:bg-white/90 transition-all duration-200 hover:scale-110"
    [class.text-red-500]="isFavorite && !isLoading"
    [class.text-gray-400]="!isFavorite && !isLoading"
    [class.text-blue-500]="isLoading"
    [disabled]="isLoading"
    >
    <!-- Spinner cuando está cargando -->
    @if (isLoading) {
      <i
        class="fas fa-spinner fa-spin text-lg transition-all duration-200"
      ></i>
    }
    <!-- Icono de corazón cuando no está cargando -->
    @if (!isLoading) {
      <i
        class="text-lg transition-all duration-200"
        [class.fas]="isFavorite"
        [class.far]="!isFavorite"
        [class.fa-heart]="true"
      ></i>
    }
  </button>
}
